import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import CountUp from "react-countup";

import { useTranslation } from "react-i18next";

function PayedStatsCard({ payed }) {
  const {
    t,
  } = useTranslation();

  return (
    <Card className="card-stats">
      <Card.Body>
        <Row>
          <Col xs="5">
            <div className="icon-big text-center">
              <i className="nc-icon nc-credit-card text-success"></i>
            </div>
          </Col>
          <Col xs="7">
            <div className="numbers">
              <p className="card-category">{t("common.labels.paidPlural")}</p>
              <Card.Title as="h4">
                <CountUp start={0} end={payed} duration={2} decimals={2} />{"  "}€
              </Card.Title>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export default PayedStatsCard;
